import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'StarDimensionInputs',
  props: {
    disabledShapes: {},
    storeShapeGetter: {},
    storeShapeUpdater: {},
    action: {},
    prefix: {},
    isCutout: { type: Boolean },
    modifierAction: {}
  },
  setup(__props: any) {

const store = useStore();
const { isCutout, action, prefix, modifierAction } = __props;

const dimensions = computed(() => store.getters.getMeasurements( 'star', isCutout ) );
const modifiers = computed(() => store.getters.getModifiers( isCutout ));
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );

const innerRadius = computed({
	get: () => dimensions.value.inner_radius,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "inner_radius",
			value: value,
		});
	},
});

const outerRadius = computed({
	get: () => dimensions.value.outer_radius,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "outer_radius",
			value: value,
		});
	},
});

const numberOfPoints = computed({
	get: () => modifiers.value.number_of_points,
	set: (value: number) => {
		store.commit(modifierAction, {
			modifier: "number_of_points",
			value: value,
		});
	},
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ShapeInputFieldsWrapper, null, {
    default: _withCtx(() => [
      _createVNode(DimensionInput, {
        inputRef: "star-inner_radius",
        id: `${_ctx.prefix}measurements-star-inner_radius`,
        name: `${_ctx.prefix}measurements[dimensions][inner_radius]`,
        unit: "cm",
        label: dimensionLabel.value('inner_radius', 'star'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('inner_radius'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}star-inner_radius`),
        onBlur: () => _unref(addSizeToDataLayer)('inner_radius', +innerRadius.value, 'star'),
        modelValue: innerRadius.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((innerRadius).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "star-outer_radius",
        id: `${_ctx.prefix}measurements-star-outer_radius`,
        name: `${_ctx.prefix}measurements[dimensions][outer_radius]`,
        unit: "cm",
        label: dimensionLabel.value('outer_radius', 'star'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('outer_radius'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}star-outer_radius`),
        onBlur: () => _unref(addSizeToDataLayer)('outer_radius', +outerRadius.value, 'star'),
        modelValue: outerRadius.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((outerRadius).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "star-number_of_points",
        id: `${_ctx.prefix}measurements-star-number_of_points`,
        name: `${_ctx.prefix}measurements[modifiers][number_of_points]`,
        inputmode: "numeric",
        label: dimensionLabel.value('number_of_points', 'star'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}star-number_of_points`),
        onBlur: () => _unref(addSizeToDataLayer)('number_of_points', +numberOfPoints.value, 'star'),
        modelValue: numberOfPoints.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((numberOfPoints).value = $event)),
        step: 1
      }, null, 8, ["id", "name", "label", "invalid", "onBlur", "modelValue"])
    ]),
    _: 1
  }))
}
}

})